import React from 'react';
import {Modal} from "react-bootstrap";
import Money from "../../../../components/Common/Money";
import {useTranslation} from "react-i18next";
import {ReactComponent as PlusIco} from "../../../../../images/icons/plus.svg";
import {ReactComponent as MinusIco} from "../../../../../images/icons/minus.svg";
import MenuEditItemViewHelper from "../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";
import ProductAvailability from "./ProductAvailability";
import ErrorFormAlertView from "../../../../components/Common/ErrorFormAlertView";
import {scrollToProductRequiredSection} from "../../../../utils/product";

interface Props {
    productState: Record<string, any>;
    updateProductState: (productState: Record<string, any>) => void;
    simple?: true;
    onSubmit: () => void;
    productView: Record<string, any>;
    product: Record<string, any>;
    setIsProductAvailable: React.Dispatch<React.SetStateAction<boolean>>;
    isProductAvailable: boolean;
    errors: any[];
    loading: boolean;
    productItemGroup: Record<string, any> | undefined;
}

const MenuProductModalFooter = ({
                                    productState,
                                    updateProductState,
                                    simple,
                                    onSubmit,
                                    productView,
                                    setIsProductAvailable,
                                    isProductAvailable,
                                    product,
                                    errors,
                                    loading,
                                    productItemGroup
                                }: Props) => {
    const {t} = useTranslation();
    const isValid = MenuEditItemViewHelper.isValid(productView);
    const disabled = productView.disabled || !isProductAvailable;

    const increaseQuantity = () => {
        const newQuantity = productState.quantity + 1;
        updateProductState({
            ...productState,
            quantity: newQuantity,
        });
    };

    const decreaseQuantity = () => {
        const newQuantity = productState.quantity - 1;
        updateProductState({
            ...productState,
            quantity: newQuantity,
        });
    };

    const handleOnSubmit = () => {
        if (!isValid) {
            scrollToProductRequiredSection();
            return;
        }

        onSubmit();
    }

    if (simple) {
        return (
            <Modal.Footer>
                <button
                    className={`btn-spinner w-100 btn-primary btn btn-submit btn-submit-fixed-bottom ${loading ? "loading" : ""} ${!isValid ? "disabled-view" : ""}`}
                    disabled={disabled} onClick={handleOnSubmit}>
                    <span className="left spinner-border spinner-border-sm"/>
                    {`${t("common.action.add")}: `}
                    <span>
                        <Money
                            value={productState.discount_price ? productState.discount_price : productState.total_price}
                            currency={productState.total_price.currency}/>
                    </span>
                </button>
            </Modal.Footer>
        )
    }

    return (
        <Modal.Footer>
            <ProductAvailability productView={productView} product={product}
                                 productItemGroup={productItemGroup}
                                 setIsProductAvailable={setIsProductAvailable}/>
            <ErrorFormAlertView errors={errors}/>
            <div className="btn-group-submit">
                {isProductAvailable && (
                    <div className="input-group input-group-quantity gap-0">
                        <div className="input-group-prepend">
                            <button type="button" className="btn btn-default btn-icon"
                                    onClick={decreaseQuantity} disabled={productState.quantity <= 1}
                                    aria-label={`${t("common.action.decrease_quantity")} ${productState.name}`}>
                                <MinusIco aria-hidden="true"/>
                            </button>
                        </div>
                        <span className="input-group-text">{productState.quantity}</span>
                        <div className="input-group-append">
                            <button type="button" className="btn btn-default btn-icon" onClick={increaseQuantity}
                                    aria-label={`${t("common.action.increase_quantity")} ${productState.name}`}>
                                <PlusIco aria-hidden="true"/>
                            </button>
                        </div>
                    </div>
                )}
                <button
                    className={`btn-spinner w-100 btn-primary btn btn-submit btn-submit-fixed-bottom ${loading ? "loading" : ""} ${!isValid ? "disabled-view" : ""}`}
                    disabled={disabled} onClick={handleOnSubmit}>
                    <span className="left spinner-border spinner-border-sm"/>
                    {isProductAvailable ? `${t("common.action.add")}: ` : t("common.action.add")}
                    {isProductAvailable && (
                        <span>
                        <Money
                            value={productState.discount_price ? productState.discount_price : productState.total_price}
                            currency={productState.total_price.currency}/>
                    </span>
                    )}
                </button>
            </div>
        </Modal.Footer>
    )
}

export default MenuProductModalFooter;